export type { GenericOptions, KindedOptions } from './build-generic';
export { buildGeneric } from './build-generic';

export type { Contract } from './contract';
export { ContractBuilder } from './contract';

export { printContract } from './print';

export type { Access } from './set-access-control';
export type { Upgradeable } from './set-upgradeable';
export type { Info } from './set-info';

export { premintPattern } from './erc20';
export { defaults as infoDefaults } from './set-info';

export type { OptionsErrorMessages } from './error';
export { OptionsError } from './error';

export type { Kind } from './kind';
export { sanitizeKind } from './kind';

export { erc20, erc721, erc1155, governor, custom } from './api';